/**
 * Piso do estado de carga da lateral do chat — o mínimo que ele fica na tela.
 *
 * ★ Não é atraso artificial. Na `/ia` as conversas quase sempre já estão no
 * store (o popup e a rota cheia compartilham o namespace) e a próxima página
 * volta do cache em dezenas de ms — o esqueleto aparecia e sumia dentro do mesmo
 * quadro, ou nem chegava a pintar. O resultado não é "rápido": é a coluna
 * trocando de conteúdo sem ninguém ver que carregou.
 *
 * É a regra que o `CLAUDE.md` do repo já fixa para botões — "quando a chamada
 * resolve em menos de 300ms o spinner pisca e parece defeito; garanta um mínimo
 * de 600-1000ms" — aplicada a uma lista, que tolera menos tempo que um botão
 * porque o conteúdo ao redor não some.
 *
 * ⚠️ Dono ÚNICO do número. Ele governa DUAS superfícies que precisam concordar —
 * o esqueleto da primeira pintura (`chat-sidebar`) e o rodapé da rolagem
 * infinita (`view-chat`) —, e escrito nos dois viraria dois ritmos diferentes na
 * mesma coluna no primeiro ajuste.
 *
 * 420ms: acima do limiar em que um estado que aparece e some lê como defeito
 * (~300ms) e abaixo do ponto em que vira espera percebida.
 */
export const PISO_DE_CARGA_MS = 420

/**
 * Espera o que falta para o estado de carga completar o piso.
 *
 * Recebe QUANDO a carga começou, e não uma duração: assim o tempo real da rede
 * é descontado — resposta lenta não soma atraso nenhum, e só a rápida é
 * segurada. Chamar com a carga já mais longa que o piso resolve na hora.
 *
 * @param {Number} desde Timestamp (`Date.now()`) do início da carga.
 * @returns {Promise} Resolve quando o piso estiver cumprido.
 */
export function aguardarPisoDeCarga(desde) {
  const decorrido = Date.now() - desde
  const restante = PISO_DE_CARGA_MS - decorrido
  if (restante <= 0) return Promise.resolve()
  return new Promise((resolve) => setTimeout(resolve, restante))
}
